import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Observable} from "rxjs";
import {GetE015UsersCB} from "../../Ope/E015User/GetE015UsersCB";
import {DelE015UserCB} from "../../Ope/E015User/DelE015UserCB";
import {PutE015UserCB} from "../../Ope/E015User/PutE015UserCB";

@Injectable({
  providedIn: 'root'
})
export class E015UserService extends BaseService {

  public getE015Users(cb: GetE015UsersCB): Observable<any> {
    return this.execOPE(cb);
  }

  public putE015User(cb: PutE015UserCB): Observable<any> {
    return this.execOPE(cb);
  }

  public delE015User(cb: DelE015UserCB): Observable<any> {
    return this.execOPE(cb);
  }


}
